import Vue from 'vue'
import App from './App.vue'
import router, { Error404Router } from './router/index.js'
import store from './store/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import XpSearchbar from '@xpeng/searchbar'
import * as filters from './filters'
import '@/svg/index'
import { initI18n } from '@xpeng/i18n'
import config from '@/config/index.js'
// 开发环境Cookie初始化
if (process.env.NODE_ENV === 'development') {
  import('./utils/dev-cookie-init.js')
}

Vue.use(ElementUI)
Vue.config.productionTip = false

const components = { XpSearchbar }
for (let [name, component] of Object.entries(components)) {
  Vue.component(name, component)
}
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

const bootstrap = async () => {
  const i18n = await initI18n()

  // 根据环境和配置决定是否启用权限控制
  // 开发环境（process.env.NODE_ENV === 'development'）保持现有功能
  // 生产环境（process.env.NODE_ENV === 'production'）且启用了前端权限控制时，才进行权限验证
  if (config.ENABLE_FE_PERMISSION) {
    // 生产环境且启用了权限控制，先获取权限数据，再动态注册路由，最后创建Vue实例
    try {
      await store.dispatch('getUserStatus')
      // 动态添加权限路由
      router.addRoutes(store.state.userMenus)
      // 动态添加404路由
      router.addRoutes(Error404Router)
    } catch (err) {
      if (err && err.code !== 302) {
        // 可以在这里处理错误，比如跳转到登录页
        console.error('获取权限失败:', err)
      }
    }
  }

  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
  }).$mount('#app')
}
bootstrap()
